import {theme} from "Theme";
import {useFormContext, useWatch} from "react-hook-form";

import {FormCheckbox, FormInputInteger} from "base/form/components";

import Stack from "@mui/system/Stack";
import Box from "@mui/material/Box";

const PermitExtensionMaterialsEditableCells = ({
    material,
    extension,
    disabled = false,
}) => {
    const {control} = useFormContext();

    const extensionTypes = extension?.types || [];

    const isTransportExtended = useWatch({
        name: `materials.${material.id}.is_extended`,
        control,
    });

    return (
        <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            sx={{
                my: -1, // Para que ocupe todo el espacio de la celda
                mr: -1.24,
                borderLeft: `3px solid ${theme.palette.primary.main}`,
                backgroundColor: theme.palette.pageBackground.secondary,
            }}
        >
            <Box width={40}>
                <FormCheckbox
                    name={`materials.${material.id}.is_extended`}
                    disabled={disabled || !extension?.types?.includes("transport")}
                />
            </Box>
            <Box width={64}>
                <FormInputInteger
                    name={`materials.${material.id}.quantity_ext`}
                    style={{
                        maxWidth: 64,
                        "& input": {textAlign: "center", fontSize: "0.8rem", p: 0.5},
                    }}
                    disabled={
                        disabled ||
                        !extensionTypes.includes("transport") ||
                        !isTransportExtended
                    }
                />
            </Box>
        </Stack>
    );
};

export default PermitExtensionMaterialsEditableCells;
